module.exports = __webpack_public_path__ + "img/data.ed43b835.svg";